import { createContext, type ReactNode, useContext, useRef } from 'react';
import { createFavoritesStore, createPlayerStore, stores } from 'src/client/stores';

export interface Stores {
  playerStore: ReturnType<typeof createPlayerStore>['use'];
  favoritesStore: ReturnType<typeof createFavoritesStore>['use'];
}

export const StoresContext = createContext<Stores | undefined>(undefined);

interface StoresProviderProps {
  children: ReactNode;
}

export function StoresProvider({ children }: StoresProviderProps) {
  const storesRef = useRef<Stores | null>(null);

  if (storesRef.current === null) {
    const playerStore = createPlayerStore();
    const favoritesStore = createFavoritesStore();

    stores.init({
      playerStore,
      favoritesStore,
    });
    storesRef.current = {
      playerStore: playerStore.use,
      favoritesStore: favoritesStore.use,
    };
  }

  return <StoresContext.Provider value={storesRef.current}>{children}</StoresContext.Provider>;
}

export function useStores() {
  const stores = useContext(StoresContext);

  if (!stores) {
    throw new Error('useStores must be used within a StoresProvider');
  }

  return stores;
}
